import { Grid, List, ListItem } from "@mui/material";
import { NavLink, useLocation } from "react-router-dom";
import HomeIcon from "./../Assests/Home.svg";
import CompareIcon from "./../Assests/compare.svg";
import Manufacturing from "./../Assests/manufecturing.svg";
import shiftnChangeover from "./../Assests/shift-changeover.svg";
import oeecpt from "./../Assests/oee-cpt.svg";
import SourcingIcon from "./../Assests/sourcing.svg";
import flowsIcon from "./../Assests/flowstab.svg";
// import ooecpt from "./../Assests/ooe-cpt.svg";

import { useSelector } from "react-redux";

const isActiveStyle = {
  textDecoration: "none",
  color: "#ffffff",
  background: "#0921b7",
  width: "100%",
  padding: "10px",
};
const deActiveStyle = {
  textDecoration: "none",
  color: "#000",
  background: "#Ffffff",
  width: "100%",
  padding: "10px",
};

function CGOSidebar() {
  const selectedCategoryId = useSelector(
    (state: any) => state.InputDataReducers.selectedCategoryId
  );
  console.log(selectedCategoryId, 'selectedCategoryId')
  const location: any = useLocation();
  return (
    <div >

      <List>
        <ListItem className="listItem">
          <NavLink
            to="/CGOHome"
            style={({ isActive }) => (isActive ? isActiveStyle : deActiveStyle)}
            data-toggle="tooltip"
            data-placement="bottom"
            title={"Home"}
          >
            <Grid container spacing={1}>
              <Grid item xs={10} md={10} lg={10}>
                <h4>Home</h4>
                <p>Map View</p>
              </Grid>
              <Grid item xs={2} md={2} lg={2}>
                <img src={HomeIcon} className="image-icon" />
              </Grid>
            </Grid>
          </NavLink>
        </ListItem>  
        <ListItem className="listItem">
          <NavLink
            to="/demand"
            style={({ isActive }) => (isActive ? isActiveStyle : deActiveStyle)}
            data-toggle="tooltip"
            data-placement="bottom"
            title={"Demand"}
          >
            <Grid container spacing={1}>
            <Grid item xs={10} md={10} lg={10}>
                <h4>Demand</h4>
                <p>Input</p>
              </Grid>
              <Grid item xs={2} md={2} lg={2}>
                <img src={shiftnChangeover} />
              </Grid>
            </Grid>
          </NavLink>
        </ListItem>
        <ListItem className="listItem">
          <NavLink
            to="/existingplanet"
            style={({ isActive }) => (isActive ? isActiveStyle : deActiveStyle)}
            data-toggle="tooltip"
            data-placement="bottom"
            title={"Existing Plant"}
          >
            <Grid container spacing={1}>
            <Grid item xs={10} md={10} lg={10}>
                <h4>Existing Plant</h4>
                <p>Input</p>
              </Grid>
              <Grid item xs={2} md={2} lg={2}>
                <img src={SourcingIcon} />
              </Grid>
            </Grid>
          </NavLink>
        </ListItem>
        <ListItem className="listItem">
          <NavLink
            to="/CGOflows"
            style={({ isActive }) => (isActive ? isActiveStyle : deActiveStyle)}
            data-toggle="tooltip"
            data-placement="bottom"
            title={"Flows"}
          >
            <Grid container spacing={1}>
            <Grid item xs={10} md={10} lg={10}>
                <h4>Flows</h4>
                <p>Output Preview</p>
              </Grid>
              <Grid item xs={2} md={2} lg={2}>
                <img src={flowsIcon} />
              </Grid>
            </Grid>
          </NavLink>
        </ListItem>
    
      </List>
      
    </div>
  );
}

export default CGOSidebar;
